export const MAX_WATER_METERS = 20;
